import useCopyToClipboard from '@subflow-frontend/hooks/useCopyToClipboard';
import { IFile } from '@subflow-frontend/@types/file';
import { useGenerateLinkToFile } from '@subflow-frontend/hooks/content/useGenerateLinkToFile';

export const useCopyFileLinkToClipboard = () => {
  const { copy } = useCopyToClipboard();
  const { generateLink } = useGenerateLinkToFile();
  const copyFileLinkToClipboard = async (
    file: Pick<IFile, 'id' | 'merchantId'>
  ) => {
    const link = generateLink(file);
    return {
      result: await copy(link),
      link,
    };
  };

  return {
    copyFileLinkToClipboard,
  };
};
